export var BasketViewMode;
(function (BasketViewMode) {
    BasketViewMode["PROGRAM"] = "PROGRAM";
    BasketViewMode["REPLACE"] = "REPLACE";
    BasketViewMode["ASSIGNMENT"] = "ASSIGNMENT";
    BasketViewMode["CREATE_TEMPLATE"] = "CREATE_TEMPLATE";
})(BasketViewMode || (BasketViewMode = {}));
//# sourceMappingURL=basket-view-mode.js.map